import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const PersonasPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "PersonasPage" */ './Container'),
  'page'
);
